export default {
  "workspace": {
    "rename_modal_dialog": {
      "title": "Rename {type} {name}",
      "name_input": "{type} new name",
      "submit_button": "Update"
    },
    "create_modal_dialog": {
      "title": "Créer un nouvel espace de travail.",
      "folder_name_input": "Nom de l'espace de travail",
      "submit_button": "Créer l'espace de travail",
      "subtitle": "Nommez-le et choisissez son apparence dans la barre latérale.",
      "name_placeholder": "Nommez votre espace de travail",
      "usage": "{used} sur {limit} espaces de travail"
    },
    "customize": {
      "title": "Personnaliser l'espace de travail",
      "subtitle": "Le nom de cet espace de travail et son apparence dans la barre latérale.",
      "name": "Nom",
      "color": "Couleur de fond",
      "avatar": "Avatar",
      "initials": "Initiales",
      "icon": "Icône",
      "emoji": "Émoji",
      "customColor": "Couleur personnalisée",
      "save": "Enregistrer",
      "saved": "Espace de travail mis à jour"
    },
    "menu": {
      "customize": "Personnaliser",
      "settings": "Paramètres de l'espace de travail",
      "label": "Options de l'espace de travail"
    },
    "switcher": {
      "current": "Espace de travail {workspace} dans {organization}"
    }
  }
};
